module.exports = __webpack_public_path__ + "static/Portfolio14-df8a013efba701eb260ce9327184420c.jpg";